import React from 'react';
import { PropTypes } from 'prop-types';
import pluralize from 'pluralize';
import { Icon } from '@unite-us/ui';
import { getReferralStatus, handleKeyPress } from './utils';
import { isEmpty } from 'lodash';
import classNames from 'classnames';
export function ReferralCard(_ref) {
  var referral = _ref.referral,
    index = _ref.index,
    selectedIndex = _ref.selectedIndex,
    onClick = _ref.onClick,
    errors = _ref.errors,
    expandReferralsCard = _ref.expandReferralsCard,
    isEmrSource = _ref.isEmrSource;
  var programs = referral.programs,
    service = referral.service;
  var onCardClick = function onCardClick() {
    onClick(index);
  };
  var status = getReferralStatus(referral);
  var backgroundColor = selectedIndex === index ? 'bg-dark-fill-blue' : '';
  var actionItemsCount = Object.values(errors).filter(Boolean).length;
  var actionItems = pluralize('Action Item', actionItemsCount, true);
  var xlOrLgVisibility = classNames({
    'lg:visible': isEmrSource,
    'lg:block xl:block': !isEmrSource
  });
  var inverseXlOrLgVisibility = classNames({
    'lg:hidden': isEmrSource,
    'lg:hidden xl:block': !isEmrSource
  });
  return !isEmpty(programs) ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(backgroundColor, " border border-solid border-blue-border rounded cursor-pointer"),
    onClick: onCardClick,
    onKeyDown: function onKeyDown(e) {
      return handleKeyPress(e, onCardClick);
    },
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex xs:flex-wrap-reverse justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap mb-2"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "uppercase font-black text-dark-grey whitespace-pre " + (expandReferralsCard ? 'hidden' : 'block')
  }, "Referral ".concat(index + 1, ": ")), /*#__PURE__*/React.createElement("p", {
    className: "font-hairline text-dark-grey sm:hidden md:hidden ".concat(xlOrLgVisibility)
  }, status)), /*#__PURE__*/React.createElement("div", {
    className: "sm:hidden md:hidden ".concat(xlOrLgVisibility)
  }, !actionItemsCount ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-none sm:hidden md:hidden"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconCheck",
    color: "#4ECE3D",
    className: "mr-1 mt-px"
  }), /*#__PURE__*/React.createElement("h4", {
    className: "text-green font-extrabold mb-2"
  }, "Ready")) : /*#__PURE__*/React.createElement("h4", {
    className: "text-red flex-none font-extrabold mb-2 sm:hidden md:hidden ".concat(xlOrLgVisibility)
  }, actionItems))), /*#__PURE__*/React.createElement("h4", {
    className: "mb-2 text-purple font-black sm:hidden md:hidden ".concat(xlOrLgVisibility)
  }, service === null || service === void 0 ? void 0 : service.name), /*#__PURE__*/React.createElement("div", {
    className: "pl-5 sm:hidden md:hidden ".concat(xlOrLgVisibility)
  }, programs.map(function (program) {
    return /*#__PURE__*/React.createElement("p", {
      className: "mb-2",
      key: "program-".concat(program === null || program === void 0 ? void 0 : program.id, "-name")
    }, program === null || program === void 0 ? void 0 : program.name);
  })), /*#__PURE__*/React.createElement("div", {
    className: expandReferralsCard ? 'hidden' : "sm:block md:block + ".concat(inverseXlOrLgVisibility)
  }, !actionItemsCount ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-none"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconCheck",
    color: "#4ECE3D",
    className: "mr-1 mt-px"
  }), /*#__PURE__*/React.createElement("h4", {
    className: "text-green font-extrabold mb-2"
  }, "Ready")) : /*#__PURE__*/React.createElement("h4", {
    className: "text-red flex-none font-extrabold mb-2"
  }, actionItems)), /*#__PURE__*/React.createElement("div", {
    className: expandReferralsCard ? "block" : "hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex xs:flex-wrap-reverse justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap mb-2"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "uppercase font-black text-dark-grey whitespace-pre"
  }, "Referral ".concat(index + 1, ": ")), /*#__PURE__*/React.createElement("p", {
    className: "font-hairline text-dark-grey"
  }, status)), !actionItemsCount ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-none"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconCheck",
    color: "#4ECE3D",
    className: "mr-1 mt-px"
  }), /*#__PURE__*/React.createElement("h4", {
    className: "text-green font-extrabold mb-2"
  }, "Ready")) : /*#__PURE__*/React.createElement("h4", {
    className: "text-red flex-none font-extrabold mb-2"
  }, actionItems)), /*#__PURE__*/React.createElement("h4", {
    className: "mb-2 text-purple font-black"
  }, service === null || service === void 0 ? void 0 : service.name), /*#__PURE__*/React.createElement("div", {
    className: "pl-5"
  }, programs.map(function (program) {
    return /*#__PURE__*/React.createElement("p", {
      className: "mb-2",
      key: "program-".concat(program === null || program === void 0 ? void 0 : program.id, "-name")
    }, program === null || program === void 0 ? void 0 : program.name);
  }))))) : null;
}
;
ReferralCard.propTypes = {
  referral: PropTypes.shape({
    programs: PropTypes.array.isRequired,
    service: PropTypes.object.isRequired
  }).isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number,
  errors: PropTypes.object
};
ReferralCard.defaultProps = {
  selectedIndex: 0,
  errors: {}
};
export default ReferralCard;
//# sourceMappingURL=ReferralCard.js.map